var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChildScienceWithBlob(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 500 500",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fill: "#ABD04D",
    d: "M 344.975 39.441 C 377.173 38.97 412.763 70.485 439.595 125.986 C 466.143 181.488 483.938 260.978 477.442 337.645 C 471.227 414.311 440.158 487.689 399.203 496.623 C 357.968 505.561 306.281 450.53 266.74 422.779 C 227.198 395.5 199.519 396.44 156.87 387.973 C 113.939 379.978 55.756 363.044 30.9 310.365 C 6.327 258.156 14.802 169.729 43.329 113.758 C 71.854 57.315 120.152 33.326 158.847 36.62 C 197.259 40.381 226.067 71.895 254.876 71.895 C 283.967 71.425 312.777 39.441 344.975 39.441 Z",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_2",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 2",
    transform: "matrix(1.355281, 0, 0, 1.459529, 41.367863, 17.914383)",
    style: {}
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M197.46,67.33c-1.16-11.94-3.22-23.12-11.16-32.55-5.74-6.82-14.6-11.13-22.51-14.94-10-4.79-19.64-7.95-30.75-8.57-9.71-.54-19.93,1.22-29.28,3.78C83.23,20.68,65.83,33.38,58.1,53.62a44.11,44.11,0,0,0-.37,29.66,58.15,58.15,0,0,0,14,29.52c12.72,14.54,32.2,21.36,50.88,23.4a65.1,65.1,0,0,0,51.86-16.91C189.31,105.46,199.51,88.22,197.46,67.33Z",
    style: {
      fill: "rgb(250, 172, 114)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M53.16,66.57a3.18,3.18,0,0,0-.55-.55,5,5,0,0,0-4.15-2.21,3.61,3.61,0,0,0-1.47.25,5.39,5.39,0,0,0-5.54,7.06,5.27,5.27,0,0,0,3.44,3.62,4,4,0,0,0,1.79.08l.29.1a5.66,5.66,0,0,0,6.41-2.41,3.53,3.53,0,0,0,.44-2.5A2.92,2.92,0,0,0,53.16,66.57Z",
    style: {
      fill: "rgb(255, 224, 189)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M215.51,72.84c-.81-3.22-4.31-4.61-7.36-4.4-2.67.19-5.26,2.23-5.13,5.13a5.26,5.26,0,0,0,3.36,4.77,2.68,2.68,0,0,0,.28.18,6.66,6.66,0,0,0,2.4.83,5.71,5.71,0,0,0,1.89-.07l.24,0,0,0A4.68,4.68,0,0,0,212,79l-.33-.09c.52-.3.64-.27.33.09a5,5,0,0,0,3-2.32A5.32,5.32,0,0,0,215.51,72.84Z",
    style: {
      fill: "rgb(255, 224, 189)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M194.2,50.42a68.55,68.55,0,0,0-10.73-17c-4.54-5.41-10-8-16.37-10.59-2.29-.92-4.1,2.52-2.38,4.08,16.89,15.33,24.75,39.91,16.48,61.6-8.46,22.18-32,39.3-55.61,40.64a2.13,2.13,0,0,0,0,4.25c14,.49,28.37-1.12,40.66-8.34a63.51,63.51,0,0,0,27.69-33C198.76,79.11,199.69,63.28,194.2,50.42Z",
    style: {
      fill: "rgb(233, 136, 73)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M98.88,68.51a9.18,9.18,0,0,0-5.53-5.11,8.38,8.38,0,0,0-4.17-1,15.13,15.13,0,0,0-2.92.35,10.6,10.6,0,0,0-5,3A10.52,10.52,0,1,0,97.15,79.4a10.58,10.58,0,0,0,2-4.21A9.24,9.24,0,0,0,98.88,68.51Z",
    style: {
      fill: "rgb(243, 113, 87)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M172.88,65.73a9.59,9.59,0,0,0-8.49-4.87l-.21,0a8.21,8.21,0,0,0-1.32.08,11.19,11.19,0,0,0-4.87,1.4,11.5,11.5,0,0,0-5.42,6.94C151,74.83,154.66,80.55,160,82.13a11.34,11.34,0,0,0,11.2-2.89,11.2,11.2,0,0,0,1.66-13.51Z",
    style: {
      fill: "rgb(243, 113, 87)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M238.51,136.12c-6-3.79-18.19-4.47-27.41-1.35a13.23,13.23,0,0,0-12.74,9.06c-2.29,6.77.33,14.18,5.6,18.81,6.15,5.41,14.13,6.12,21.91,4.79,7-1.19,14.29-4.26,17.74-10.92C247.29,149.39,245.43,140.48,238.51,136.12Z",
    style: {
      fill: "rgb(217, 227, 112)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M237.15,137a7.27,7.27,0,0,0-4.05-3.17,3.34,3.34,0,0,0,1-1.08,2.12,2.12,0,1,0-3.88-1.64,3.47,3.47,0,0,0-.08,1.6,1.44,1.44,0,0,0,.13.43c-1.6-.25-3.26-.36-4.79-.54-5.54-.65-11.12-.48-16.69-.87-2.44-.17-2.82,3.53-.56,4.17,5.41,1.56,10.64,3.67,16.13,4.93,4.32,1,8.73,2.59,12.38-.42A2.84,2.84,0,0,0,237.15,137Z",
    style: {
      fill: "rgb(245, 241, 155)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M220.68,145l-.24-.16a2.19,2.19,0,1,0,0,3.78l.24-.16A2,2,0,0,0,220.68,145Z",
    style: {
      fill: "rgb(245, 241, 155)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M207.26,143.74a2.26,2.26,0,0,0-3.51-.45l-.07.09-.14.06a2.25,2.25,0,0,0,.54,4.11C206.19,148.17,208.58,145.81,207.26,143.74Z",
    style: {
      fill: "rgb(245, 241, 155)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M216,156.07a4,4,0,0,0-.66-.49,2.1,2.1,0,0,0-1.94-.51l-.5.13a3,3,0,0,0-2,1.8,3.21,3.21,0,0,0,.16,2.77l0,.09a3.1,3.1,0,0,0,1.87,1.45,3,3,0,0,0,2.74-.57A3.11,3.11,0,0,0,216,156.07Z",
    style: {
      fill: "rgb(245, 241, 155)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M238.24,59.8a3.28,3.28,0,0,0-.91-1.21,2.29,2.29,0,0,0-1.48-.9,2,2,0,0,0-1.21.22,3.26,3.26,0,0,0-1,.34,3.25,3.25,0,1,0,4.77,3.67A3.35,3.35,0,0,0,238.24,59.8Z",
    style: {
      fill: "rgb(245, 241, 155)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M253.24,56.23a4.22,4.22,0,0,0-1.4-2,2.19,2.19,0,0,0-3,0,4.15,4.15,0,0,0-1.4,2,3,3,0,1,0,5.81,0Z",
    style: {
      fill: "rgb(245, 241, 155)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M231.41,122a78.76,78.76,0,0,0,6.35-17.13c1.78-6.78,2.4-13.58,3.88-20.37a2.25,2.25,0,0,0-4.34-1.2c-2.06,6.64-4.87,12.84-6.65,19.61a78.29,78.29,0,0,0-3,18.31A20.13,20.13,0,0,0,213,126.09c-2.06,1.69.72,5.35,2.88,3.73,4-3,9-4.43,13.87-2.58,4.16,1.59,6.13,5.25,9.12,8.22,1.27,1.26,3.88.4,3.73-1.54C242.14,128,236.79,123.76,231.41,122Z",
    style: {
      fill: "rgb(208, 237, 245)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M17.61,84.16a2.13,2.13,0,0,0-4.1,1.13c1.18,6.71.1,15.63,6.16,20.46a1.78,1.78,0,0,0,2.92-.77C25.4,97.74,20,90.56,17.61,84.16Z",
    style: {
      fill: "rgb(208, 237, 245)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M17.19,76.14C16.05,74,13,74.05,10.86,74.36c-2.26.35-3.9,2-5.62,3.35C3,79.5,5.85,82.82,8.19,81.54c1.33-.73,2.89-.67,4.37-1s3.33-.42,4.28-1.64A2.4,2.4,0,0,0,17.19,76.14Z",
    style: {
      fill: "rgb(208, 237, 245)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M243.44,76c-.4-2.81-4.32-3.72-6.58-2.88a2.43,2.43,0,1,0,1.88,4.45c-.4.2.57-.06.1,0h.32l.31.07h.05l0,0,.57.25.2.09.06,0c.24.11.49.23.75.32C242.64,78.89,243.62,77.31,243.44,76Z",
    style: {
      fill: "rgb(208, 237, 245)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M40.18,154.44l.11,0c-.23-.7-.48-1.39-.73-2.09-.5-12-2.83-25.53-9.61-35.63-.72-3.16-2.12-6.26-3.07-9.3a2.11,2.11,0,0,0-1-1.2,6.64,6.64,0,0,0-.67-.78,6.66,6.66,0,0,0-9.25.32c-3.35,3.65-1.7,8.55-.56,12.7,1.36,4.94,2.08,9.91,5.25,13.9a2.75,2.75,0,0,0,0,2.53c1.13,2.63,2.11,6.11,4.3,8.13,2.3,5,4.92,9.82,7.17,14.86a3.51,3.51,0,0,0,4.55,1.78A4.29,4.29,0,0,0,40.18,154.44Z",
    style: {
      fill: "rgb(255, 212, 125)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M25,102.3c-1.91-.39-3.5.47-5.28,1.11l-2.76,1a13.67,13.67,0,0,0-3.27,1.21c-2.3,1.1-.68,4.93,1.74,4.13L21,107.9c1.69-.56,3.74-.86,4.93-2.26C26.81,104.58,26.62,102.62,25,102.3Z",
    style: {
      fill: "rgb(254, 240, 129)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M22.81,116.17c-.88-2.57-4.8-1.54-4.1,1.13,3.4,12.9,5.5,26.46,12.17,38.23.74,1.3,3,.79,2.91-.79C32.83,141.23,27.12,128.81,22.81,116.17Z",
    style: {
      fill: "rgb(254, 240, 129)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M146.53,10.06C143,7.57,140.3,5,136.19,3.34A34.83,34.83,0,0,0,122.9,1c-7.57,0-19.12,1.63-20.72,10.85a3.58,3.58,0,0,0,2.4,4.23c6.37,2.62,12.82-1.17,19.11-2,6-.81,15-1.21,20.77.94C147.48,16.11,148.86,11.69,146.53,10.06Z",
    style: {
      fill: "rgb(182, 115, 60)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M142,182.6q-13.71.06-27.4.08a7.34,7.34,0,0,0-2.59.46,20.31,20.31,0,0,0-2.29-.86,5,5,0,0,0-6.23,4.74c.19,12.5,1.31,24.79,2.63,37.21.45,4.24,3.61,6.84,7.91,6,7.47-1.43,9.06-8.57,9.5-15.1,0-.55.07-1.11.11-1.66a9.13,9.13,0,0,0,6.14,1.1c.8,3.31,1.48,6.62,2,9.83.45,2.84,3.6,4.57,6.19,4.71l2.18.11c3.53.18,6.68-3.18,6.62-6.63-.18-10.81-.71-20.87,1.7-31.55A6.77,6.77,0,0,0,142,182.6Z",
    style: {
      fill: "rgb(141, 189, 230)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M145.51,187.1a2.49,2.49,0,0,0-.21-.72,3.62,3.62,0,0,0,.19-.4,3.06,3.06,0,0,0-.8-3c-3.64-3.71-8.89-1.1-13.45-.73-5.64.46-11.27.66-16.92.78-2,0-3.18,3.13-1.11,4.08a42.31,42.31,0,0,0,18,4c1.49,0,3.09,0,4.69-.05a80.35,80.35,0,0,0,3.87,24.26c.59,1.87,3.47,2.06,4,0A78.3,78.3,0,0,0,145.51,187.1Z",
    style: {
      fill: "rgb(96, 165, 218)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M149,165.67c.47-5.53.9-11.87-.18-17.21a13.53,13.53,0,0,0-1.92-4.85c1.91-2.89.94-7.91-2.95-8.57a36.12,36.12,0,0,0-13.53.77,14,14,0,0,0-2.45.87c-4.76-1.37-9.89-1.61-14.78-1.8a4.32,4.32,0,0,0-4.55,3.33,5.49,5.49,0,0,0-2.12,3c-1.72,6.73-2.36,13.83-3.31,20.72-.53,3.89-.83,8.08.78,11.62a4.31,4.31,0,0,0-.14,2.56,4.47,4.47,0,0,0,.66,1.33,4.2,4.2,0,0,0,1.66,1.79l.08,0a4.43,4.43,0,0,0,4.08.19c3.41,1.37,7.32,1.31,11.07,1.07,6-.4,12.84,0,18.68-1.68a11.75,11.75,0,0,0,2.24-.89,5.05,5.05,0,0,0,5.68-2.09c1.33-2,1.44-4.58,1.38-6.89A16.49,16.49,0,0,0,149,165.67Z",
    style: {
      fill: "rgb(201, 231, 249)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M132.14,155.8a15.52,15.52,0,0,0-16.49-4.35,18.3,18.3,0,0,0-11.38,11.77,27.77,27.77,0,0,0-1.27,8.35c0,3.44.94,5,2.23,8a1.94,1.94,0,0,0,1.92,1.12,6.66,6.66,0,0,0,5.89,2.43c3.89-.28,8.22-.73,11.81-2.37,4.84,3,11.76-1.7,12-7.32C137.06,167.09,136.52,160.75,132.14,155.8Z",
    style: {
      fill: "rgb(226, 244, 253)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M191,39.36a69.75,69.75,0,0,0-40.23-27.87l1.13.14c1.18.1,1.29-1.44.54-2-3-2.21-7.23-1.74-10.67,0a81.62,81.62,0,0,0-11.5-.84A19.57,19.57,0,0,1,133.05,7c3.46-1.9,6.89-2.11,10.68-2.72,1.25-.2,1.08-2,0-2.35-6.33-1.82-13.21,1.78-17.22,7a85.72,85.72,0,0,0-12.94,1.54,17.61,17.61,0,0,1,4.25-4c3.49-2.36,7-2.53,11-3.29,1.35-.26,1.17-2.19,0-2.56a12.51,12.51,0,0,0-8.62.55A.85.85,0,0,0,119.38,0c-8.31-.55-16.09,6.53-19.27,14.22-1,.36-1.91.73-2.86,1.12a1.77,1.77,0,0,0-.92,2.33C74,21.65,55.9,41.24,53.29,64.13,50,93,69,120.49,95.2,131.36A79.56,79.56,0,0,0,111,136a5.89,5.89,0,0,1,.92.2c.72.12,1.45.22,2.17.33,1.76.25,3.53.48,5.3.63a91.54,91.54,0,0,0,14.81,0,88.4,88.4,0,0,0,25.93-6.13,76.42,76.42,0,0,0,20.19-11.83C204.3,99.78,208.44,64.68,191,39.36ZM107.53,8c2.92-2.57,6.24-3.9,9.71-5.25a23.5,23.5,0,0,0-7.58,8.61c-2.23.55-4.45,1.18-6.63,1.91A25.09,25.09,0,0,1,107.53,8ZM109,131.62c-26.73-5.92-48.71-27.26-52.21-55C53.44,50,72.52,23.11,98.84,18.53l-.09.5a.63.63,0,0,0,1.21.33l.43-1.05a45.49,45.49,0,0,1,7.14-.46c.52,0,.51-.77,0-.8a46.27,46.27,0,0,0-5.13,0q2.8-.89,5.67-1.57c-.06.23-.12.46-.17.69-.36,1.74,2.28,2.48,2.66.74a17.26,17.26,0,0,1,.66-2.15A89.68,89.68,0,0,1,124.14,13a13.69,13.69,0,0,0-.65,1.93.6.6,0,0,0,1.1.46,28,28,0,0,1,1.74-2.5,84.57,84.57,0,0,1,11.15.34c-.12.17-.26.34-.37.51-.4.63.46,1.16,1,.74s.91-.7,1.37-1c14.87,1.84,29,7.87,40.3,18.92,20.46,20,24.79,53.79,5.68,76.31C167.48,129.85,135.45,137.48,109,131.62Z",
    style: {
      fill: "rgb(79, 63, 58)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M49.32,71.85c-1.61.19-2.8.54-4.34-.18a3.83,3.83,0,0,1-2.43-3.76,4.35,4.35,0,0,1,2.91-3.18c1.57-.63,2.87,0,4.44-.16a.43.43,0,0,0,.41-.53c-.53-2.29-4-2.37-5.75-1.9a6.56,6.56,0,0,0-1.84,12.13c2.06,1.37,5.76,2,7.54-.14C50.91,73.36,50.59,71.7,49.32,71.85Z",
    style: {
      fill: "rgb(79, 63, 58)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M218.09,72.91a6.08,6.08,0,0,0-11.39-2c-.3.55.49,1.25.91.7,2.24-2.87,7.35-2.1,7.5,1.92a3.17,3.17,0,0,1-2.31,3.23c-1.54.46-2.91-.54-4.42-.15a1.45,1.45,0,0,0-1,1.76c.72,3,5.14,2.57,7.23,1.52A6.49,6.49,0,0,0,218.09,72.91Z",
    style: {
      fill: "rgb(79, 63, 58)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M121.16,46a1.51,1.51,0,0,0-3,0c-.14,2-.24,4-.27,6,0,1.74-.16,3.41.73,5a1.44,1.44,0,0,0,2.46,0C122.63,53.9,121.5,49.24,121.16,46Z",
    style: {
      fill: "rgb(79, 63, 58)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M134.86,51.35c-.12-1.79-.33-3.55-.58-5.33-.26-1.94-3.27-1.38-3.32.45s-.07,3.76.07,5.63a12.79,12.79,0,0,0,.85,4.89c.65,1.28,2.38.77,2.8-.36C135.27,55,135,53,134.86,51.35Z",
    style: {
      fill: "rgb(79, 63, 58)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M209.18,118.78c-3.78.82-7.3,2.83-10.83,4.41-4.28,1.92-8.57,3.83-12.84,5.77-8.27,3.75-16.3,7.87-24.42,11.87-.57.28-.16,1.27.44,1,8-3.09,16-6,23.9-9.34q6.07-2.57,12.11-5.18c4.22-1.81,9-3.26,12.77-5.9A1.47,1.47,0,0,0,209.18,118.78Z",
    style: {
      fill: "rgb(79, 63, 58)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M228.83,77.45c-2.78,9.07-6.6,17.75-8.12,27.18a1.26,1.26,0,0,0,0,.52c-1,.82-1.93,1.77-2.85,2.63-1.62,1.53-4,3.29-4.58,5.53a.54.54,0,0,0,.52.68c2.25-.19,4.19-2.14,5.93-3.47,2-1.54,4.47-3.12,5.63-5.42a1.27,1.27,0,0,0-1.42-1.84c-.22.07-.43.16-.64.25,3.06-8.37,4.27-17.18,6.4-25.81A.47.47,0,0,0,228.83,77.45Z",
    style: {
      fill: "rgb(79, 63, 58)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M226,113.17c-1.53-.67-3-.17-4.54.19-1.38.32-3,.49-3.79,1.76a1.15,1.15,0,0,0,.4,1.52c1.15.85,2.82.37,4.14.2,1.47-.19,3-.18,4.1-1.26A1.54,1.54,0,0,0,226,113.17Z",
    style: {
      fill: "rgb(79, 63, 58)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M225.24,119.41c-1.5-.66-3.35.07-4.86.51a1.26,1.26,0,0,0,.34,2.47c1.5-.07,3.61,0,4.78-1A1.25,1.25,0,0,0,225.24,119.41Z",
    style: {
      fill: "rgb(79, 63, 58)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M238.76,119.47a386.81,386.81,0,0,0,6.47-38.81.22.22,0,0,0,0-.08,5.56,5.56,0,0,0,1.59-1.78c1.74-3.13-.54-5.67-3.47-7.19-3.69-1.93-8.63-1.51-11.5,1.33-.9.89-.08,1.71.87,1.18,2.41-1.33,5.11-1.37,7.82-1.08,3.31.35,5.82,4.5,1.73,5.95s-8.63-1.59-11.13-4.51c-.35-.41-.87.11-.69.52a11.3,11.3,0,0,0,8.14,6.82,9.05,9.05,0,0,0,5.54-.6,379.72,379.72,0,0,0-8.5,37.56,1.7,1.7,0,0,0-.36,3.32,21.9,21.9,0,0,1,14.9,27.23c-3.51,12-15,20.39-27.44,20.69-12.14.3-23.34-7.83-25.69-20-2.38-12.31,6.73-23.6,18.63-26,.46-.09.34-.79-.11-.8-10.27-.29-19,7.28-21.68,17-2.86,10.33,2,21.44,10.34,27.79,18.7,14.33,48.2.53,50.62-22.48C256,134.45,249.43,123,238.76,119.47Z",
    style: {
      fill: "rgb(79, 63, 58)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M240.71,129.63c-.39-.42-.94.19-.61.61a20.9,20.9,0,0,1,1.52,22.41c-4.25,7.24-11.26,8.56-18.89,9.29a1.42,1.42,0,0,0-.37,2.78c8.47,2.77,18.58-3.62,22.47-11C249.22,145.41,246.89,136.2,240.71,129.63Z",
    style: {
      fill: "rgb(79, 63, 58)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M238.92,58.2c-1.14-1.44-4-2.39-5.39-.72a.91.91,0,0,0-.17.68.27.27,0,0,0-.14.07,3.61,3.61,0,0,0-.73,4.88,3.82,3.82,0,0,0,5.59.69A3.94,3.94,0,0,0,238.92,58.2ZM236.65,62c-2,1.6-4.07-1.49-2.92-3.26a.56.56,0,0,0,.32.06,3.2,3.2,0,0,1,2.78.61A1.61,1.61,0,0,1,236.65,62Z",
    style: {
      fill: "rgb(79, 63, 58)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M238.85,44.33c-.21-1.65-2.17-3-3.69-2-.68.46-.7,1.74.26,1.92l.47.1s0,.06,0,.09a7.3,7.3,0,0,1-.42,1.45.93.93,0,0,0,.55,1.35C237.67,47.66,239,45.87,238.85,44.33Z",
    style: {
      fill: "rgb(79, 63, 58)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M243.2,29.19a1.75,1.75,0,0,0-3.35-.4,1.89,1.89,0,0,0,.26,2.77C241.63,32.8,243.59,31.14,243.2,29.19Z",
    style: {
      fill: "rgb(79, 63, 58)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M252.76,53.41a5.79,5.79,0,0,0-3.38-1.53c-1.17-.1-2.91.17-3.5,1.31a1,1,0,0,0,.6,1.46c1.24.26,2.4-.32,3.66.26A2.21,2.21,0,0,1,251.31,58c-1.6,3.25-5.37-.44-3.46-2.33.49-.49-.23-1.17-.74-.75a3.91,3.91,0,0,0-.41,5.56c1.65,2,4.57,1.66,6.22-.17A4.92,4.92,0,0,0,252.76,53.41Z",
    style: {
      fill: "rgb(79, 63, 58)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M257,42.24a1.1,1.1,0,0,0-.25-.56l-.22-.26a1.8,1.8,0,0,0-2.56,0c-.63.67-1.36,1.51-.8,2.48s1.64.75,2.56.62S257.15,43.11,257,42.24Z",
    style: {
      fill: "rgb(79, 63, 58)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M242.52,137.51a33.64,33.64,0,0,0-6.67-3.6,3.76,3.76,0,0,0,.08-2.88,4.74,4.74,0,0,0-2.28-2.49c-1-.51-2.89-.81-3.5.46a1.19,1.19,0,0,0-.12.51,4.18,4.18,0,0,0-1.62,2.6,19.57,19.57,0,0,0-6.64.55c-1.13.3-.78,1.52.37,1.46a26.45,26.45,0,0,1,6.57.44,3.79,3.79,0,0,0,4.74,1.6l.26-.13a40.06,40.06,0,0,1,4.22,2c-10.64,1.62-20.58-.09-31.08-3a.42.42,0,0,0-.33.77c10.4,6.68,23.93,7.31,35.66,4.39A1.46,1.46,0,0,0,242.52,137.51Zm-8.8-4.58a1,1,0,0,1-.24.31s0,0,0,0a1.38,1.38,0,0,1-.25.17h0l0,0a1.76,1.76,0,0,1-2.3.52,1.88,1.88,0,0,1-1-2.16,2.11,2.11,0,0,1,.65-1.31l0,0a1.08,1.08,0,0,0,.28.15l.48-.2h0l.11-.08a1.74,1.74,0,0,1,2.28,2.52Z",
    style: {
      fill: "rgb(79, 63, 58)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M97.22,144c-4.4-2.51-8.33-5.34-13-7.46-4.16-1.87-8.43-3.55-12.73-5.08-8.78-3.11-18.54-6.52-27.93-6.64a1.37,1.37,0,0,0-.36,2.67c8.64,2.92,17.83,4.17,26.54,7q6.33,2,12.48,4.54c4.73,1.9,10,3.54,14.58,5.77C97.28,145,97.73,144.26,97.22,144Z",
    style: {
      fill: "rgb(79, 63, 58)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M42.44,121.75a20.8,20.8,0,0,1-2.76-2.16,29,29,0,0,0-3-1.82c-1.77-1-3.52-2-5.55-2.17a1.35,1.35,0,0,0-1,2.28c1.38,1.47,3.39,2.16,5.23,2.89a29,29,0,0,0,3.24,1.15,20.18,20.18,0,0,1,3.23.72C42.51,122.92,43,122,42.44,121.75Z",
    style: {
      fill: "rgb(79, 63, 58)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M36.51,122.67c-3-1.1-7-2.47-10.23-1.51A1,1,0,0,0,26,123c2.8,1.8,7.07,1.59,10.24,1.37A.87.87,0,0,0,36.51,122.67Z",
    style: {
      fill: "rgb(79, 63, 58)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M151.51,157.46c-.76-6.78-1.36-13.69-3.2-20.27a.43.43,0,0,0-.85.11c-1.08,13.21,1.7,26.5,1.35,39.76a131,131,0,0,1-45,1.8c-1.23-14,.28-27.89,3.31-41.57a.52.52,0,0,0-1-.28c-5.55,13.92-7.09,28.63-6,43.53a1.94,1.94,0,0,0,1.4,1.83,123.74,123.74,0,0,0,48.34-1.7,1.62,1.62,0,0,0,1.31-1.33,1.39,1.39,0,0,0,1-1.15C153.35,171.34,152.28,164.3,151.51,157.46Z",
    style: {
      fill: "rgb(79, 63, 58)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M154.2,69.87a2,2,0,0,0-3.77,1c1.92,8.29,1.52,16.43-3.17,23.8a25.67,25.67,0,0,1-21.61,11.75c-18,.15-30.75-19.1-23.62-35.81.26-.63-.6-1.19-1-.56-9.75,18,2.92,39.16,23.18,40.17C144.83,111.27,161.57,89.59,154.2,69.87Z",
    style: {
      fill: "rgb(79, 63, 58)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M156.84,237.47c-2.72-.74-5.7-.28-8.5-.19l-7.75.26a27.3,27.3,0,0,0-1.08-5.89,13.63,13.63,0,0,0,5.6-.25,2,2,0,0,0,.29-.15c0,.13,0,.26.09.39a1.46,1.46,0,0,0,2.79,0c1.31-3.75.93-8,1.05-11.93.15-4.48.26-9,.39-13.46s.25-9,.28-13.47c0-3.85.49-8-1-11.64-.12-.28-.55-.43-.71-.1-1.34,2.69-1.49,5.75-1.67,8.74-1.38-1.34-3.31-1.85-4.46-3.63-1-1.63-2.07-4.3-1.54-6.22.13-.45-.58-.79-.79-.33-1.31,2.84-1.87,5.17-.41,8.16,1.14,2.32,4,5.61,6.93,4.62,0,0,.08,0,.12,0-.27,4.31-.46,8.64-.64,13-.18,4.48-.38,9-.56,13.46a85.47,85.47,0,0,0-.32,9.75c-2.1-.67-4.56-.25-6.73-.1a28.45,28.45,0,0,0-4.78.63,54.34,54.34,0,0,0-4.37-13.43,6,6,0,0,0,2.52-.53,1.37,1.37,0,0,0,0-2.35c-1.39-.69-3-.53-4.58-.48l-.92,0a12.54,12.54,0,0,0-.61-3.26.6.6,0,0,0-1.07-.14,13.17,13.17,0,0,0-1.61,4.07l-.19.11a1,1,0,0,0-.15,1.58c-.33,2-.48,4-.73,5.92a59.22,59.22,0,0,0-1,7.72,36.75,36.75,0,0,0-6.55.07,30.05,30.05,0,0,0-6.68.61c.08-2.91-.72-5.93-1-8.81-.42-4.06-.77-8.13-1-12.2-.27-4.57-.66-9.25-.91-13.93l.14.05c3,.44,5.84-2.24,7.51-4.49a11.44,11.44,0,0,0,1.94-4c.45-1.73.11-3.05.06-4.78a.48.48,0,0,0-1,0c-.14,2.33-2.17,5.25-3.7,6.89s-3.58,2.13-5.13,3.44c-.11-2.88-.16-5.75-.07-8.58,0-.54-.77-.52-.82,0-.81,8.88-1.92,17.35-1.61,26.34q.22,6.57.89,13.13c.34,3.42.24,7,2.07,9.95a1.24,1.24,0,0,0,2.23-.29,2.8,2.8,0,0,0,.06-.28,26.49,26.49,0,0,0,7,.52c2.3,0,4.82.32,7.09-.2a1.24,1.24,0,0,0,2.19.17c1.91-3.13,1.66-7.24,2-10.82.16-1.75.44-3.63.58-5.51h1l.82,0c-.06,5.89.62,11.17,3,16.53.67,1.5,3,.68,3-.81,0-.75,0,.44-.12-.33a32.77,32.77,0,0,0,4.52.58h.05c-.85,2.43-.78,4.9-1.21,7.46a2,2,0,0,0,1.87,2.46l9.4-.21c2.81-.06,5.82.26,8.5-.62A1.66,1.66,0,0,0,156.84,237.47Z",
    style: {
      fill: "rgb(79, 63, 58)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M127.83,229.92a.05.05,0,0,0,0,.1A.05.05,0,1,0,127.83,229.92Z",
    style: {
      fill: "rgb(79, 63, 58)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M115.78,238.23a28.12,28.12,0,0,0-2-5.88.47.47,0,0,0-.86.11,21,21,0,0,0-.59,4.17c-1.73-.13-3.49,0-5.2,0-2.33,0-4.63-.3-6.78.71a1.7,1.7,0,0,0,0,2.91c2.16,1,4.44.68,6.78.65s5,.2,7.39-.43A1.84,1.84,0,0,0,115.78,238.23Z",
    style: {
      fill: "rgb(79, 63, 58)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M128.71,155.94a2.62,2.62,0,0,0-2.41-.65,1.94,1.94,0,0,0-1,.27,2.77,2.77,0,0,0,.69,5,3,3,0,0,0,3.07-1.21A2.75,2.75,0,0,0,128.71,155.94Z",
    style: {
      fill: "rgb(79, 63, 58)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M129.24,170.24a2.75,2.75,0,0,0-3-.66,2.64,2.64,0,0,0-.49.08,2.72,2.72,0,0,0-1.91,2.76,3,3,0,0,0,2.26,2.7,3.25,3.25,0,0,0,3.4-1.31A2.86,2.86,0,0,0,129.24,170.24Z",
    style: {
      fill: "rgb(79, 63, 58)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M44,150.29c-1.5-6.52-3.29-13.54-6.13-19.74a5.32,5.32,0,0,0,1.46-.7A1.56,1.56,0,0,0,39,127c-1.85-.44-3.72.23-5.54.66A16,16,0,0,0,28,129.63a1,1,0,0,0,.23,1.77,14.93,14.93,0,0,0,5.37-.15c.75-.11,1.57-.18,2.38-.29a90,90,0,0,0,2.44,11.56c1.4,5.44,4.7,12.09.61,16.85-6.68,7.21-11.53-10.27-13-14.26q-3.71-10.35-7.47-20.67Q15.91,117.18,13.1,110a13.88,13.88,0,0,0,14-4,43.9,43.9,0,0,0,2.63,6.9c.67,1.33,2.41.31,2.22-.93-.91-6-3.62-11.94-5.54-17.64-1.62-4.82-3.31-9.58-5.31-14.25,1.65-1.48,2.48-3.33.74-5.42-3.24-3.88-11.27-2.36-14.62.45a.8.8,0,0,0-.29.61c-3.75.9-8.53,3.19-6.46,7.84a4.16,4.16,0,0,0,1.82,2C7.78,104.46,14,123.08,20.6,141.67c2.27,6.42,4,16.71,9.83,21.05a8.78,8.78,0,0,0,10.49-.27C44.74,159.54,45,154.65,44,150.29ZM3.86,78.56a6.92,6.92,0,0,1,3.49-2.07.93.93,0,0,0,.85.21c2.57-.69,4.94-1.6,7.66-1.52a6,6,0,0,1,3.2.64c3,2.26-3.16,4.36-4.43,4.87a42.21,42.21,0,0,1-7.85,2.43C4,83.64,2,80.9,3.86,78.56Zm11.51,4.82a25.57,25.57,0,0,0,4.88-2.62c1.18,5.43,2.71,10.75,4.31,16.08.55,1.82,1,3.7,1.56,5.59-1.51,1.83-2.85,3.54-5.09,4.65a18.12,18.12,0,0,1-8.46,1.54Q8.11,97.22,3.34,86C7,87,12.73,84.5,15.37,83.38Z",
    style: {
      fill: "rgb(79, 63, 58)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M24.86,102.34c-4-1-10.35-.39-12.52,3.83a.88.88,0,0,0,1.2,1.2c1.81-1,3.1-2.5,5.13-3.24a14,14,0,0,1,6.06-.82C25.28,103.36,25.38,102.48,24.86,102.34Z",
    style: {
      fill: "rgb(79, 63, 58)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M29.37,118.4a16.54,16.54,0,0,0-1.15-3.72c-.65-1.4-1.48-2.77-2.06-4.2-.28-.69-1.41-.41-1.14.32.52,1.4.84,2.92,1.27,4.36a16.81,16.81,0,0,0,1.76,3.8A.73.73,0,0,0,29.37,118.4Z",
    style: {
      fill: "rgb(79, 63, 58)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M36.56,142.32c-.93-2.75-2.08-5.44-2.92-8.22a.53.53,0,0,0-1,.28c.79,2.79,1.28,5.66,2,8.48.61,2.45,1,5.28,2.4,7.39a.83.83,0,0,0,1.53-.41C38.59,147.29,37.37,144.72,36.56,142.32Z",
    style: {
      fill: "rgb(79, 63, 58)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M139.57,137.31a1,1,0,0,0-1.88-.25c-.56,1.23-.64,3-1.3,4.1-3.26,5.24-7.1.51-8.95-2.11a1.58,1.58,0,0,0-2.45-.32c-1,1.23-2.1,2.45-3.13,3.69a20.86,20.86,0,0,0-1.46,2c-.15.23-.33.48-.6.48s-.41-.18-.57-.35c-2.42-2.66-3.67-5.69-4.81-9.1-.22-.5-1-.13-.85.36.62,2.94.84,11.86,4.84,12.75,3,.66,5.77-3.49,7.7-6.2,2.18,2.6,5.32,5.28,8.65,4.46C138.83,145.85,140.47,141,139.57,137.31Z",
    style: {
      fill: "rgb(79, 63, 58)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M207.7,141.56a.55.55,0,0,0-.3-.85c-2.29-.4-4.84.63-5.41,3.08a4.31,4.31,0,0,0,3.33,5.2,4.14,4.14,0,0,0,4.69-3.91A4.7,4.7,0,0,0,207.7,141.56Zm-2.42,5.27a2.47,2.47,0,0,1-1.46-2.88,2.71,2.71,0,0,1,1-1.47.68.68,0,0,0,.37.65c1,.47,2.61.51,2.7,2A2,2,0,0,1,205.28,146.83Z",
    style: {
      fill: "rgb(79, 63, 58)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M222.74,145.42c-.43-.41-1.37-.3-1.47.39a4.69,4.69,0,0,1-.24,1.72,1.14,1.14,0,0,1-1.55.5c-1.73-.78-.7-3,1-2.85a.51.51,0,0,0,.14-1,3.17,3.17,0,0,0-3.31,1.55,2.92,2.92,0,0,0,.94,3.75,3,3,0,0,0,3.9-.14C223.14,148.45,223.87,146.5,222.74,145.42Z",
    style: {
      fill: "rgb(79, 63, 58)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M217.7,157.11a1.08,1.08,0,0,0-1.52-.33,1.35,1.35,0,0,1-.2,2,1.16,1.16,0,0,1-1,.52,1.28,1.28,0,0,1-1.27-1.27,1.57,1.57,0,0,1,1.6-1.6,1,1,0,0,1,.26,0,.53.53,0,0,0-.21-.88,2.38,2.38,0,0,0-2.65,1.06,2.72,2.72,0,0,0,.47,3.24,2.83,2.83,0,0,0,3.36.44C217.62,159.77,218.54,158.24,217.7,157.11Z",
    style: {
      fill: "rgb(79, 63, 58)"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChildScienceWithBlob);
export default __webpack_public_path__ + "static/media/childScienceWithBlob.50bde79c81849f117cd3dffefe973edc.svg";
export { ForwardRef as ReactComponent };